/* Lumena: let Nova currency converter convert Sternify bundle prices */
(function(){
  var SEL='.st_discounted-price,.st_compare-at-price,.st_price';
  var t;
  function run(){
    var n=0;
    document.querySelectorAll(SEL).forEach(function(e){
      if(!e.classList.contains('money')){e.classList.add('money');n++;}
    });
    if(n && window.baCurr && typeof baCurr.refreshConversion==='function'){
      try{baCurr.refreshConversion();}catch(_){}
    }
  }
  function sched(){clearTimeout(t);t=setTimeout(run,150);}
  new MutationObserver(sched).observe(document,{childList:true,subtree:true});
  document.addEventListener('DOMContentLoaded',sched);
  sched();
})();
